var TorsoBehavior = require('backbone-torso/modules/Behavior');
var navViews = require('./nav/navViews');
var footerViews = require('./footer/footerViews');
var launcherAppInterface = require('./launcherApplicationInterface');

/**
 * Perspective Behavior handling navigation and footer layout.
 *
 * @class PortalPerspectiveLayoutBehavior
 * @constructor
 */
module.exports = TorsoBehavior.extend({
  /**
   * @method setNavViewKey
   * @param navViewKey {String} the key from navViews of the nav view to render.
   */
  setNavViewKey: function(navViewKey) {
    this.set('navViewKey', navViewKey);
  },

  /**
   * @method setFooterViewKey
   * @param footerViewKey {String} the key from footerViews of the footer view to render.
   */
  setFooterViewKey: function(footerViewKey) {
    this.set('footerViewKey', footerViewKey);
  },

  /**
   * @method initialze
   * @override
   */
  initialize: function() {
    this.on('change:navViewKey change:footerViewKey', this.view.render, this.view);
  },

  /**
   * @method attachTrackedViews
   * @override
   */
  attachTrackedViews: function() {
    if (this.view.isAttached()) {
      this.view.attachView('nav', this.view.getNavView(), { shared: true });
      this.view.attachView('footer', this.view.getFooterView(), { shared: true });
    }
  },

  /**
   * @method _detached
   * @private
   */
  _detached: function() {
    this.view.unregisterTrackedView(this.view.getNavView());
    this.view.unregisterTrackedView(this.view.getFooterView());
  },

  mixin: {
    /**
     * @return {TorsoView} the nav view to render.
     */
    getNavView: function() {
      var navViewKey = this.get('navViewKey');
      var navView = null;
      if (navViewKey) {
        navView = navViews[navViewKey];
      } else if (launcherAppInterface.isAtHospital()) {
        navView = navViews.eregPatient;
      } else {
        navView = navViews.patient;
      }
      return navView;
    },

    /**
     * @return {TorsoView} the footer view to render.
     */
    getFooterView: function() {
      var footerViewKey = this.get('footerViewKey');
      var footerView = null;
      if (footerViewKey) {
        footerView = footerViews[footerViewKey];
      } else if (launcherAppInterface.isAtHospital()) {
        footerView = footerViews.ereg;
      } else {
        footerView = footerViews.portal;
      }
      return footerView;
    }
  }
});
